<div class="p-3">
  <div class="px-4 py-4 box-white-rounded">
    <div class="mb-3">
      <ion-label class="color-medium fw-bold">{{
        'parametersProduct.productInstallationAt' | translate
      }}</ion-label>
    </div>

    <ion-list lines="none">
      <ion-item>
        <ion-label>{{
          'parametersProduct.productInstallationAtSmall' | translate
        }}</ion-label>
        <ion-label slot="end" class="fw-light">
          {{ getInstallationDate() }}
        </ion-label>
      </ion-item>
    </ion-list>

    @if (isSupportTechnique() && deviceTableData) {
      <div class="my-3">
        <ion-label class="color-medium fw-bold">{{
          'parametersProduct.devicetable' | translate
        }}</ion-label>
      </div>

      <ion-list lines="none">
        <ion-item>
          <ion-label>{{
            'parametersProduct.devicetable.nodeid' | translate
          }}</ion-label>
          <ion-label slot="end" class="fw-light">
            {{
              Number(getDataValue(deviceTableData!.nodeId))
                .toString(16)
                .padStart(4, '0')
                .toUpperCase()
            }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label>{{
            'parametersProduct.devicetable.presenceproduit' | translate
          }}</ion-label>
          <ion-label slot="end" class="fw-light">
            {{
              getDataValueFromList(
                deviceTableData?.presenceProduit,
                DeviceTableNodePresence
              ) | translate
            }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label>{{
            'parametersProduct.devicetable.dureeabsence' | translate
          }}</ion-label>
          <ion-label slot="end" class="fw-light">
            {{ getMinutesValue(deviceTableData?.dureeAbsence, this.translate) }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label>{{
            'parametersProduct.devicetable.dureetotal' | translate
          }}</ion-label>
          <ion-label slot="end" class="fw-light">
            {{ getMinutesValue(deviceTableData?.dureeTotal, this.translate) }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label>{{
            'parametersProduct.devicetable.dureeabsencetotal' | translate
          }}</ion-label>
          <ion-label slot="end" class="fw-light">
            {{
              getMinutesValue(
                deviceTableData?.dureeAbsenceTotal,
                this.translate
              )
            }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label>{{
            'parametersProduct.devicetable.compteurAbscence' | translate
          }}</ion-label>
          <ion-label slot="end" class="fw-light">
            {{ getDataValue(deviceTableData?.compteurAbscence) }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label>{{
            'parametersProduct.devicetable.versionlogiciel' | translate
          }}</ion-label>
          <ion-label slot="end" class="fw-light">
            {{ getDataValue(deviceTableData?.firmwareVersion) }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label>{{
            'parametersProduct.devicetable.firmwareversion' | translate
          }}</ion-label>
          <ion-label slot="end" class="fw-light">
            {{ getDataValue(deviceTableData?.gblVersion) }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label>{{
            'parametersProduct.devicetable.serialnumber' | translate
          }}</ion-label>
          <ion-label slot="end" class="fw-light">
            {{ getDataValue(deviceTableData?.serialNumber) }}
          </ion-label>
        </ion-item>
      </ion-list>
    }
  </div>
</div>
